import { SortOrder } from "sprint-common-web";

import { SeasonListingItem } from "./SeasonListingItem";

export interface SeasonListingFilters {
    page: number;
    pageSize: number;
    sortBy: keyof SeasonListingItem;
    sortOrder: SortOrder;
    orphanedOnly?: boolean;
    includeMerged?: boolean;
}

export const defaultSeasonListingFilters: SeasonListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc",
    orphanedOnly: false,
    includeMerged: false
};
